module.exports = __webpack_public_path__ + "static/media/certi.33f6dcc5.png";